module.exports = __webpack_public_path__ + "media/images/logo/sto-a04661ba0a1084fd657f0853686e4d11.gif";